import { Link } from "react-router-dom";
import ApperIcon from "@/components/ApperIcon";

const NotFound = () => {
  return (
    <div className="min-h-screen bg-background-primary flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        <div className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-6">
          <ApperIcon name="MapPin" className="w-10 h-10 text-primary" />
        </div>
        
        <h1 className="text-heading-xl text-white mb-4 font-display">
          404 - Pagina non trovata
        </h1>
        
        <p className="text-body-base text-gray-400 mb-8">
          Spiacenti, la pagina che stai cercando non esiste o è stata spostata.
        </p>
        
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 bg-primary hover:bg-primary-600 rounded-button text-white font-medium transition-colors duration-normal shadow-lg"
        >
          <ApperIcon name="Home" className="w-4 h-4" />
          Torna alla Dashboard
        </Link>
      </div>
    </div>
  );
};

export default NotFound;